import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="border-t border-slate-200 bg-white mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="w-7 h-7 bg-[#002FA7] flex items-center justify-center">
              <span className="text-white font-display font-black text-[10px]">EU</span>
            </div>
            <span className="font-display font-black">Logic Lab</span>
          </div>
          <p className="text-sm text-slate-600 leading-relaxed">{t("footer_note")}</p>
        </div>
        <div>
          <div className="label-mono text-slate-500 mb-3">Prodotto</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/tests" className="hover:text-[#002FA7]">{t("nav_tests")}</Link></li>
            <li><Link to="/guides" className="hover:text-[#002FA7]">{t("nav_guides")}</Link></li>
            <li><Link to="/pricing" className="hover:text-[#002FA7]">{t("nav_pricing")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-mono text-slate-500 mb-3">Legale</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/privacy" className="hover:text-[#002FA7]">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-[#002FA7]">Termini di servizio</Link></li>
            <li><Link to="/cookies" className="hover:text-[#002FA7]">Cookie Policy</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-mono text-slate-500 mb-3">Contatti</div>
          <ul className="space-y-2 text-sm">
            <li className="text-slate-600">support@eulogiclab.eu</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-200 py-4 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} EU Logic Lab. Tutti i diritti riservati.
      </div>
    </footer>
  );
}
